<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog', false)" @keydown.esc="$emit('updateDialog', false)" max-width="1000px" transition="dialog-bottom-transition">
      <template v-slot:activator="{ props }">
        <v-btn flat class="mb-3 btn-second" v-bind="props" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <v-row align="center" justify="center" class="mb-4 mt-4">
              <v-col md="10" class="elevation-1 pt-4 pb-4" style="background: #f5f5f5">
                <a-steps :current="step">
                  <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                </a-steps>
              </v-col>
            </v-row>

            <div class="steps-content">
              <!--step 0 - Datos Generales-->
              <v-row align="start" justify="center" v-if="step == 0" transition="fade-transition">
                <v-col md="10" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step0" v-model="validStep0">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0"><b>Datos Generales</b></p>
                    </div>
                    <p>Complete la información básica de la regla de guardado</p>

                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="item.name" label="Nombre de la Regla*" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-select v-model="item.priority" :items="[1, 2, 3, 4, 5]" label="Prioridad (1 = más alta)*" :rules="[rules.required]" :disabled="disabled"></v-select>
                      </v-col>

                      <v-col cols="12">
                        <v-textarea v-model="item.description" label="Descripción" rows="2" :disabled="disabled"></v-textarea>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-combobox v-model="item.almacen" :items="almacenes" item-title="name" item-value="id" label="Almacén*" clearable :disabled="disabled" :rules="[rules.required]"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="4" v-if="!isClient()">
                        <v-combobox
                          v-model="item.client"
                          :items="clients"
                          item-title="name"
                          item-value="id"
                          label="Cliente (opcional)"
                          clearable
                          :disabled="disabled"
                          hint="Si elegís un producto, la regla queda solo para ese producto: el cliente sirve para filtrar el combo"
                          persistent-hint
                          @update:modelValue="onClientChange"
                        ></v-combobox>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-combobox
                          v-model="item.product"
                          :items="products"
                          item-title="label"
                          item-value="id"
                          label="Producto (opcional)"
                          clearable
                          :disabled="disabled || (!isClient() && item.client == null)"
                          :loading="loading_products"
                        ></v-combobox>
                      </v-col>

                      <v-col cols="6">
                        <v-switch v-model="item.is_mandatory" label="Regla Obligatoria" color="orange" :disabled="disabled"></v-switch>
                      </v-col>

                      <v-col cols="6">
                        <v-switch v-model="item.is_active" label="Activa" color="green" :disabled="disabled"></v-switch>
                      </v-col>
                    </v-row>
                  </v-form>
                  <v-btn class="float-right btn-second" v-if="step < steps.length - 1" @click="next">Siguiente</v-btn>
                </v-col>
              </v-row>

              <!--step 1 - Condiciones-->
              <v-row align="start" justify="center" v-if="step == 1" transition="fade-transition">
                <v-col md="10" class="mt-4 pr-0 pl-0">
                  <div class="px-2 py-1 mb-3 bg-subtitle-section">
                    <p class="text-subtitle-1 mb-0"><b>Condiciones de la Regla</b></p>
                  </div>
                  <p>Configure las condiciones que debe cumplir la regla de guardado</p>

                  <v-row>
                    <v-col md="12" v-if="!disabled">
                      <v-btn size="small" color="blue-grey" prepend-icon="mdi-plus" class="pl-4 text-white" @click="addCondition">
                        <span>Agregar Condición</span>
                      </v-btn>
                    </v-col>

                    <v-col md="12">
                      <div v-for="(condition, index) in item.conditions" :key="index" class="mb-4 pa-3" style="border: 1px solid #e0e0e0; border-radius: 4px">
                        <v-row align="center">
                          <v-col cols="12" md="3" class="pt-2">
                            <v-select
                              v-model="condition.condition_type"
                              :items="conditionTypes"
                              item-title="name"
                              item-value="id"
                              label="Tipo de Condición"
                              @update:model-value="resetConditionValue(condition)"
                              :disabled="disabled"
                            ></v-select>
                          </v-col>

                          <v-col cols="12" md="3">
                            <v-select
                              v-model="condition.operator"
                              :items="getOperatorsForCondition(condition.condition_type)"
                              item-title="name"
                              item-value="id"
                              label="Operador"
                              :disabled="disabled"
                            ></v-select>
                          </v-col>

                          <v-col cols="12" md="5">
                            <ConditionValueInput
                              v-model="condition.value"
                              :condition-type="condition.condition_type"
                              :zonas="zonas"
                              :tipos-ubicacion="tiposUbicacion"
                              :ubicaciones="ubicaciones"
                              :disabled="disabled"
                            ></ConditionValueInput>
                          </v-col>      

                          <v-col cols="12" md="1" v-if="!disabled" class="d-flex align-center justify-center">
                            <v-btn @click="removeCondition(index)" color="error" icon size="small">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>

                  <v-btn v-if="step > 0" @click="prev" class="mt-5" color="blue-grey">Atrás</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" :loading="loading" v-if="!disabled && step == 1">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { productoService } from "@/libs/ws/productoService";
import { clientService } from "@/libs/ws/clientService";
import { almacenService } from "@/libs/ws/almacenService";
import { zonaService } from "@/libs/ws/zonaService";
import { tipoUbicacionService } from "@/libs/ws/tipoUbicacionService";
import { ubicacionService } from "@/libs/ws/ubicacionService";
import { storageRuleService } from "@/libs/ws/storageRuleService";
import UserTypes from "@/constants/user_type";
import ValidMixin from "@/mixins/ValidMixin.vue";
import ConditionValueInput from "@/components/Rules/ConditionValueInput.vue";

export default {
  components: {
    ConditionValueInput,
  },
  mixins: [ValidMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      loading_products: false,
      validStep0: false,

      // Steps configuration
      step: 0,
      steps: [
        {
          title: "Datos Generales",
          content: "Información básica de la regla",
        },
        {
          title: "Condiciones",
          content: "Configuración de condiciones",
        },
      ],

      item: {
        id: "",
        name: "",
        description: "",
        product: null,
        client: null,
        almacen: null,
        priority: 1,
        is_mandatory: false,
        is_active: true,
        conditions: [],
      },
      defaultItem: null,

      // Listas para combos
      products: [],
      clients: [],
      almacenes: [],
      zonas: [],
      tiposUbicacion: [],
      ubicaciones: [],
      conditionTypes: [],
      operators: [],
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.disabled = this.formBtn == "";
        this.step = 0; // Reset step when opening dialog

        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
        if (this.$refs.form_step0) {
          this.$refs.form_step0.resetValidation();
        }

        if (this.editItem != null && this.editItem.id > 0) {
          this.item = JSON.parse(JSON.stringify(this.editItem));
          if (!this.item.conditions) {
            this.item.conditions = [];
          }

          //Si la regla no tiene cliente persistido (porque tiene producto: ver createItem) se
          //muestra igual el cliente del producto, asi el combo de Producto puede resolver el
          //valor ya elegido sin tener que traer TODOS los productos.
          this.item.client = this.editItem.client || (this.editItem.product ? this.editItem.product.client : null);
          if (this.item.client != null && this.item.client.id > 0) {
            this.loadProducts(this.item.client.id);
          } else if (this.isClient()) {
            this.loadProducts();
          } else {
            this.products = [];
          }
        } else {
          if (this.defaultItem != null) {
            this.item = JSON.parse(JSON.stringify(this.defaultItem));
          }
          // Agregar una condición vacía por defecto para nuevas reglas
          if (this.item.conditions.length === 0) {
            this.addCondition();
          }
          this.products = [];
          if (this.isClient()) this.loadProducts();
        }
      }
    },
    step(newStep) {
      // Cargar datos relacionados al step actual
      if (newStep === 1) {
        this.loadZonas();
        this.loadTiposUbicacion();
        this.loadUbicaciones();
      }
    }
  },
  mounted() {
    if (!this.isClient()) this.loadClients();
    else this.loadProducts(); //Usuario cliente: no hay combo de cliente, el backend fuerza el suyo
    this.loadAlmacenes();

    this.loadConditionTypes();
    this.loadOperators();
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    isClient() {
      return localStorage.getItem("user_type") == UserTypes.CLIENT;
    },

    loadProducts(client_id = null) {
      //list_minify: payload liviano (id/name/sku/label), en vez de productoService.filter()
      //que trae el producto completo (presentaciones, proveedores, etc.).
      this.loading_products = true;
      const params = {};
      if (client_id) params.client = { id: client_id };
      productoService
        .list_minify(params)
        .then((response) => {
          this.products = response.result.list;
        })
        .catch(() => {
          this.products = [];
        })
        .finally(() => {
          this.loading_products = false;
        });
    },

    onClientChange(client) {
      //Cambiar (o limpiar) el cliente invalida el producto elegido: pertenece a otro cliente.
      this.item.product = null;
      this.products = [];
      if (client != null && client.id) this.loadProducts(client.id);
    },

    loadClients() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("clientService.filter error", e);
        });
    },

    loadAlmacenes() {
      almacenService.filter({}).then((response) => {
        this.almacenes = response.result.list;
      });
    },

    loadZonas() {
      zonaService.list_minify({ 
        almacen: this.item.almacen,
        allow_packing: 0,
        allow_recepcion: 0,
        allow_expedicion: 0
      }).then((response) => {
        this.zonas = response.result.list;
      });
    },

    loadTiposUbicacion() {
      tipoUbicacionService.filter({ 
        sucursal: this.item.almacen.sucursal,
        allow_packing: 0,
        allow_recepcion: 0,
        allow_expedicion: 0
      }).then((response) => {
        this.tiposUbicacion = response.result.list;
      });
    },

    loadUbicaciones() {
      ubicacionService.filter({ 
        almacen: this.item.almacen,
        allow_packing: 0,
        allow_recepcion: 0,
        allow_expedicion: 0
      }).then((response) => {
        this.ubicaciones = response.result.list;
      });
    },

    loadConditionTypes() {
      storageRuleService.getConditionTypes().then((response) => {
        this.conditionTypes = response.result;
      });
    },

    loadOperators() {
      storageRuleService.getOperators().then((response) => {
        this.operators = response.result;
      });
    },

    addCondition() {
      this.item.conditions.push({
        condition_type: "",
        operator: "",
        value: ""        
      });
    },

    removeCondition(index) {
      this.item.conditions.splice(index, 1);
    },

    resetConditionValue(condition) {
      condition.value = "";
      condition.operator = "";
    },

    getOperatorsForCondition(conditionType) {
      // Filtrar operadores según el tipo de condición
      if (conditionType === "ubicaciones_especificas" || conditionType === "zona" || conditionType === "tipo_ubicacion") {
        return this.operators.filter((op) => ["in", "not_in"].includes(op.id));
      }
      if (conditionType === "level") {
        return this.operators.filter((op) => ["equals", "less_than", "less_than_or_equal", "greater_than"].includes(op.id));
      }
      return this.operators;
    },

    // Métodos de navegación entre steps
    async next() {
      // Validar datos obligatorios del step actual antes de avanzar
      if (this.step === 0) {
        // Validar formulario del step 0
        if (this.$refs.form_step0) {
          const { valid } = await this.$refs.form_step0.validate();
          if (!valid) {
            this.toast.error("Por favor complete todos los campos obligatorios");
            return;
          }
        }
      }

      if (this.step < this.steps.length - 1) {
        this.step++;
      }
    },

    prev() {
      if (this.step > 0) {
        this.step--;
      }
    },

    createItem() {
      if (this.loading) return;

      if (this.valid) {
        this.loading = true;

        var data = JSON.parse(JSON.stringify(this.item));
        data.conditions_arr = data.conditions;
        delete data.conditions;

        //El cliente del combo es el filtro que habilita elegir producto. Si hay producto,
        //el producto ya determina su cliente: persistirlo ademas ampliaria la regla a todo
        //el cliente, porque ProductStorageRule::GetUbicacionesByRules() matchea product OR client.
        data.client = this.item.product ? null : this.item.client;

        if (this.item.id > 0) {


          //Hay que recorrer data.conditions y transformar los values que sean vengan del backend
          data.conditions_arr.forEach((condition) => {
            condition.value = condition.value.map(item =>{
              if (typeof item === "object" && item !== null && 'id' in item) {
                return item.id;
              }
              return item;
            });
          });

          this.service
            .update(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("La " + this.modal_title + " se modificó correctamente.");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((response) => {
              this.toast.error(response.msg);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.service
            .create(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("La " + this.modal_title + " se creó correctamente");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((e) => {
              this.toast.error(e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
  },
};
</script>
